// extracted by mini-css-extract-plugin
export default {"languageFooter":"language-footer_languageFooter__a1TF4","languageFooterText":"language-footer_languageFooterText__ctQQF","link":"language-footer_link__miy8J"};